module.exports = __webpack_public_path__ + "static/media/10.28ed9911.png";